import { NgOptimizedImage } from "@angular/common";
import { Component, input } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NewsroomArticle } from "../../newsroom/newsroom-article";

@Component({
  selector: "app-news-card",
  templateUrl: "./news-card.component.html",
  styleUrls: ["./news-card.component.scss"],
  imports: [RouterModule, NgOptimizedImage],
})
export class NewsCardComponent {
  public readonly config = input<NewsroomArticle | undefined>();
  public readonly isNewsroomHome = input(false);
}
